import {useI18n} from 'i18n/I18nContext'
import {useFormik} from 'formik'
import {useCsvImport} from 'organization/Event/Integrations/CsvImport/CsvImportProvider'
import React, {useEffect} from 'react'
import {toast} from 'react-toastify'

export const SendModal = (props: {
  show: boolean
  toggle: () => void
  emails: string[]
  fileName: string
  onFinish: () => void
  totalEmails: number
}) => {
  const {show, toggle, emails, fileName, onFinish, totalEmails} = props
  const {startImport, loading} = useCsvImport()
  const {t} = useI18n()

  const {handleSubmit, handleChange, values, resetForm} = useFormik({
    initialValues: {reservation: false},
    onSubmit: async ({reservation}) => {
      const success = await startImport(fileName, emails, reservation)
      if (success === true) {
        toast.success(t('orgCsv.toastImportStarted'))
        toggle()
        onFinish()
      }
    },
  })

  useEffect(() => {
    resetForm()
  }, [show, resetForm])

  return (
    <>
      <div
        onClick={toggle}
        className={`offcanvas__overlay ${show ? 'overlay-open' : ''}`}
      ></div>
      <section className={`speaker__popup-area ${show ? 'open' : ''}`}>
        <div className="popup__wrapper">
          <div className="popup__title-wrapper">
            <h3 className="popup__title">{t('orgCsv.sendTitle')}</h3>
          </div>
          <div className="popup__input-wrapper">
            <form onSubmit={handleSubmit}>
              <div className="singel__input-field mb-35 mt-15">
                <p>
                  {t('orgCsv.sendTotalLabel')} <b>{totalEmails}</b>
                </p>

                <label className="input__field-text">
                  {t('orgCsv.sendReserveHint')}
                </label>

                <div className={`bd-theme-toggle `}>
                  <label
                    className="bd-theme-toggle-main"
                    style={{width: '100%'}}
                    htmlFor="csv-import-reservation-toggle"
                  >
                    <span className={`bd-theme-toggle-dark `}>
                      {t('common.yes')}
                    </span>
                    <input
                      name="reservation"
                      type="checkbox"
                      id="csv-import-reservation-toggle"
                      checked={values.reservation}
                      onChange={handleChange}
                    />
                    <i className="bd-theme-toggle-slide"></i>
                    <span className={`bd-theme-toggle-light `}>
                      {t('common.no')}
                    </span>
                  </label>
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className={
                  loading ? 'disableBtnStyle w-100' : 'input__btn w-100'
                }
              >
                {t('orgCsv.sendStart')}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  )
}
